import {createAsyncThunk} from '@reduxjs/toolkit';
import {axiosErrorHandler} from '../../config';
import {getTransactionsReuest} from '../../services/logsApi';
import {ItransactionReq} from '../../services/logsApi/types';
import {ITransaction} from '../../../entities/logs';
import {PaginatedType} from '../../../types';

export const getTransactions = createAsyncThunk<
	PaginatedType<ITransaction>,
	{shop_id: number; params: ItransactionReq}
>(
	'@@logs/getTransactions',
	async ({shop_id, params}: {shop_id: number; params: ItransactionReq}, {rejectWithValue}) => {
		try {
			const {data} = await getTransactionsReuest(shop_id, params);
			return data;
		} catch (err) {
			return rejectWithValue(axiosErrorHandler(err));
		}
	},
);
